<template>
  <div
    v-if="operations && operations.length > 0"
    id="company-display-operations"
  >
    <div class="container d-flex justify-content-center">
      <BushelBtn
        class="mt-3"
        style="max-width: 30rem; width: 100%"
        @click="toggleOperations"
      >
        <div class="d-flex justify-content-center">
          <template v-if="!showOperations">
            Expand Operations
          </template>
          <template v-else>
            Collapse Operations
          </template>
          <i
            id="op-button-icon"
            class="fas fa-angle-down pl-2 pr-2"
            style="font-size: 1.5rem"
            :class="showOperations ? 'show' : 'hide'"
          />
        </div>
      </BushelBtn>
    </div>
    <div
      id="op-display-overflow"
      class="d-flex"
    >
      <div
        id="op-display-container"
        :class="showOperations ? 'show' : 'hide'"
      >
        <OperationsSelect
          :operations="operations"
          :selected-operation="selectedOperation"
          :set-selected-operation="setSelectedOperation"
        />
        <div
          id="op-name-banner"
          class="bg-primary container d-flex"
        >
          <h5 class="text-white pt-3 pb-3 mb-0">
            {{ companyName }}'s Operations
          </h5>
        </div>
        <OperationsOverview :operation="selectedOperation" />
        <OperationsDetails :operation="selectedOperation" />
        <div class="row d-flex flex-flow m-0">
          <OperationsShipping :operation="selectedOperation" />
          <OperationsLicenses :operation="selectedOperation" />
          <OperationsDocuments :operation="selectedOperation" />
          <OperationsMinimums :operation="selectedOperation" />
          <OperationsCertifications :operation="selectedOperation" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OperationsSelect from "./operations/OperationsSelect.vue";
import OperationsOverview from "./operations/OperationsOverview.vue";
import OperationsDetails from "./operations/OperationsDetails.vue";
import OperationsShipping from "./operations/OperationsShipping.vue";
import OperationsLicenses from "./operations/OperationsLicenses.vue";
import OperationsDocuments from "./operations/OperationsDocuments.vue";
import OperationsMinimums from "./operations/OperationsMinimums.vue";
import OperationsCertifications from "./operations/OperationsCertifications.vue";
import BushelBtn from "@/components/common/BushelBtn.vue";

export default {
  components: {
    OperationsSelect,
    OperationsOverview,
    OperationsDetails,
    OperationsShipping,
    OperationsLicenses,
    OperationsDocuments,
    OperationsMinimums,
    OperationsCertifications,
    BushelBtn,
  },
  props: {
    companyName: { type: String, require: true },
    operations: { type: Array, require: true },
  },
  data() {
    return {
      showOperations: false,
      selectedOperation: this.operations[0],
    };
  },
  methods: {
    toggleOperations() {
      this.showOperations = !this.showOperations;
    },
    setSelectedOperation(operation) {
      this.selectedOperation = operation;
    },
  },
};
</script>

<style lang="scss" scoped>
#company-display-operations {
  max-width: inherit;

  #op-button-icon {
    transition: transform 500ms;
    &.hide {
      transform: rotate(0deg);
    }
    &.show {
      transform: rotate(180deg);
    }
  }

  #op-display-overflow {
    overflow: hidden;
    margin: 0 -1rem;
    padding: 0 1rem;

    #op-display-container {
      display: flex;
      width: 100%;
      flex-direction: column;
      transition: all 750ms;
      position: relative;

      #op-name-banner {
        margin: 0 -1rem;
        width: calc(100% + 2rem);
      }

      &.hide {
        margin-top: -100%;
        visibility: hidden;
        opacity: 0;
      }

      &.show {
        margin: 0;
        opacity: 1;
      }
    }
  }
}
</style>
